import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from '@kyruus/intl';
import { Link } from '@biome-design-system/ui/Link';
import { ListItem } from '@biome-design-system/ui/ListItem';
import { ListItemText } from '@biome-design-system/ui/ListItemText';

import { type GetUpdatedSearch, type Log } from 'Src/types';
import { messages } from './messages';

interface RefinedSearchMessageProps {
  getUpdatedSearch: GetUpdatedSearch;
  log: Log;
}

export const RefinedSearchMessage = ({
  getUpdatedSearch,
  log
}: RefinedSearchMessageProps) => {
  const history = useHistory();
  const queryParams = new URLSearchParams(history.location.search);
  const unifiedTerm = queryParams.get('unified');

  const restartSearchUrl = getUpdatedSearch([
    {
      action: 'delete_key',
      key: 'patient_search_refiner'
    },
    {
      action: 'delete_key',
      key: 'psr_refined'
    }
  ]);
  const handleOnClick = (): void => {
    log('user_action.refined_search.new_search', {
      unified: unifiedTerm
    });
  };

  return (
    <ListItem disableGutters={true}>
      <FormattedMessage
        {...messages.wouldYouLikeToRestartYourSearch}
        values={{
          term: (
            <Link
              component={RouterLink}
              onClick={handleOnClick}
              to={restartSearchUrl}
              sx={(theme) => ({
                fontWeight: theme.typography.fontWeightBold
              })}
            >
              {unifiedTerm}
            </Link>
          )
        }}
      >
        {(message) => (
          <ListItemText
            primaryTypographyProps={{ variant: 'body1' }}
            primary={message}
          />
        )}
      </FormattedMessage>
    </ListItem>
  );
};
